import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { AppFeatures } from './components/AppFeatures';
import { Pricing } from './components/Pricing';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <Hero />
        <Services />
        <AppFeatures />
        <Pricing />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;